const Core = require('./Core')
module.exports = Core
